// extracted by mini-css-extract-plugin
export default {"headerStyle":"Fachdaten_headerStyle__vprWo","valueStyle":"Fachdaten_valueStyle__m7bef","keineAngabenStyle":"Fachdaten_keineAngabenStyle__SlX2G"};